import React, { useEffect, useState } from "react";
import { IconButton, MainLayout, UpgradeCard } from "../../../components";
import { AiOutlinePlus } from "react-icons/ai";
import { connect, useSelector } from "react-redux";
import { logout } from "../../../redux/actions/login";
import DashboardPage from "./dashboard";
import { handleMainTab } from "../../../redux/actions/standard/homeActions";
import ROUTES from "../../constants/routes";
import { useNavigate } from "react-router-dom";
import authHeader from "../../../services/auth/auth-header";
import { getApi } from "../../../services/helpers/apiCall";
import { campaignsLimit, toAbsoluteUrl } from "../../../services";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  overflow: "none",
  height: "44%",
  marginTop: "1%",
  marginBottom: "2%",
};

// get step data from redux main state
const authData = (state) => state.auth;
// get step data from redux main state
const data = (state) => state.standardDashboard;

function Dashboard(props) {
  const [campaigns, setCampaigns] = useState(0);
  const [openModal, setOpenModal] = React.useState(false);

  let client = useSelector(authData);
  let clientData = useSelector(data);

  let navigate = useNavigate();
  let { companyId } = client?.client;
  let createNewGame = async () => {
    let apiCallRequest = {
      url: `/companies/${companyId}`,
      data: null,
      config: {
        headers: authHeader(),
      },
    };
    getApi(apiCallRequest)
      .then((res) => {
        let bucketName = res.data.bucket_name;
        if (
          campaignsLimit[bucketName] &&
          campaignsLimit[bucketName].limit > campaigns
        ) {
          props.handleMainTab();
          navigate(`${ROUTES.HOME}`, { replace: true });
        } else {
          setOpenModal(true);
        }
      })
      .catch((err) => {
        console.log(err.message, " dashboard");
      });
  };
  useEffect(() => {
    let campaigns = clientData && clientData.campaigns;
    if (campaigns && campaigns.length > 0) {
      setCampaigns(campaigns.length);
    }
  }, [clientData]);
  let onCloseUpgrade = () => {
    setOpenModal(!openModal);
  };
  return (
    <MainLayout
      showProgress={false}
      showDashboardButton={true}
      logout={props.logout}
      onClick={() => createNewGame()}
      stepHandler={props.handleMainTab}
    >
      <div className="flex 2xl:flex-row xl:flex-row lg:flex-row md:flex-row flex-col 2xl:justify-between xl:justify-between lg:justify-between md:justify-between items-center  2xl:mx-24 xl:mx-20 mx-8 py-2">
        <p></p>
        <div className="-mt-44">
          {openModal ? (
            <UpgradeCard type="STANDARD" onCloseUpgrade={onCloseUpgrade} />
          ) : null}
          {/* <Modal
            open={openModal}
            onClose={() => setOpenModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={style}
              className="border-4 border-[#0094A5] rounded-md  2xl:w-[42%] xl:w-[42%] lg:w-[42%] w-[75%]"
            >
              <div
                className="border-4 border-[#FFD700]  rounded-md 2xl:2/12  bg-cover bg-no-repeat bg-center h-[50%]   bg-white"
                style={{
                  backgroundImage: `url(${toAbsoluteUrl(
                    "/media/dashboard/Campaignlimit.png"
                  )})`,
                  height: "100%",
                  width: "100%",
                }}
              >
                <div className="px-10 py-6">
                  <div className="flex flex-row items-center justify-between">
                    <h1></h1>
                    <h5 className="text-[#515556] -ml-6 text-lg font-semibold text-center">
                      Dear User, you have consumed the features of this plan.
                    </h5>
                    <RiCloseLine
                      onClick={() => setOpenModal(false)}
                      className="text-[#0094A5] cursor-pointer h-6 w-6 ml-2 rounded-full "
                    />
                  </div>

                  <div className="ml-6">
                    <p className="text-[#878787] font-medium text-[16px] my-6 text-sm  ">
                      Note that you have either;
                    </p>

                    <p className="text-[#878787] font-medium text-[16px]">
                      - Already created your 1 Assessment Game
                    </p>
                    <p className="text-[#878787] font-medium text-[16px]">
                      - Already assessed your Number of Candidates
                    </p>
                  </div>

                  <div className="mt-8 ml-6">
                    <p className="text-[#878787] font-semibold text-[16px]">
                      To continue, please get yourself additional features.{" "}
                      <span className="text-[#0094A5] font-semibold text-[16px] underline cursor-pointer">
                        {" "}
                        Click here
                      </span>{" "}
                      to buy additional features in your current plan
                    </p>
                  </div>
                </div>
              </div>
            </Box>
          </Modal> */}

          {/* <IconButton
            onClick={() => createNewGame()}
            name="Create New Assessment Game"
            customStyle="py-3 px-6   mt-[16px] mr-12"
          >
            <AiOutlinePlus className="mt-1 h-5 w-5 text-white" />
          </IconButton> */}
        </div>
      </div>
      <div className="bg-[#F5F6FA] h-max">
        <DashboardPage />
      </div>
    </MainLayout>
  );
}

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, { logout, handleMainTab })(Dashboard);
